
"use client";
import { useEffect, useState } from "react";
import Image from "next/image";
import Link from "next/link";
import style from "@/styles/SpecializedFeatures2.module.scss";
import ReadMore from "./ReadMore";
import ResponsiveSwiper from "@/Components/ResponsiveSwiper";

const chunkArray = (arr, chunkSize) => {
  const result = [];
  for (let i = 0; i < arr.length; i += chunkSize) {
    result.push(arr.slice(i, i + chunkSize));
  }
  return result;
};

const SpecializedFeatures2 = ({ data }) => {
  const [isMobile, setIsMobile] = useState(false);
  const [chunkSize, setChunkSize] = useState(4); // Default chunk size is 4

  useEffect(() => {
    const checkWidth = () => {
      const width = window.innerWidth;
      setIsMobile(width <= 575);
      if (width >= 576 && width <= 767) {
        setChunkSize(2); // For 576px to 767px, show 2 items per row
      } else if (width <= 575) {
        setChunkSize(3); // For <= 575px, show 4 items per row
      }
    };
    checkWidth();
    window.addEventListener("resize", checkWidth);
    return () => window.removeEventListener("resize", checkWidth);
  }, []);

const defaultData = {
    preheading: "",
    heading: "Explore Our Vidyalaya LMS Modules",
    decsription:
      "Discover a comprehensive suite of online learning management solutions designed to empower schools, enterprises, and organizations with cutting-edge features.",
    card: [
      {
        url: "/enterprise-learning-management-software",
        image: "/images/feature_section_img/ic_enterprise_learning.svg",
        title: "Enterprise Learning <br/> Management Software",
      },
      {
        url: "/ai-learning-management-system",
        image: "/images/feature_section_img/ic_ai_learning.svg",
        title: "AI Learning Management <br/>System",
      },
      {
        url: "/lms-learning-system",
        image: "/images/feature_section_img/ic_lms_learning.svg",
        title: "LMS Learning <br/>System",
      },
      {
        url: "/learning-management-system-for-schools",
        image: "/images/feature_section_img/ic_learning_for_schools.svg",
        title: "Learning Management System <br/> for Schools",
      },
      {
        url: "/learning-management-system-training",
        image: "/images/feature_section_img/ic_learning_training.svg",
        title: "Learning Management <br/> System Training",
      },
      {
        url: "/employee-onboarding-software",
        image: "/images/feature_section_img/ic_employee_onboarding_software.svg",
        title: "Employee Onboarding <br/> Software",
      },
      {
        url: "/lms-for-colleges",
        image: "/images/feature_section_img/ic_learning_management_system_for_colleges.svg",
        title: "LMS for Colleges",
      },
      {
        url: "/best-learning-management-platform",
        image: "/images/feature_section_img/ic_online_learning_management_platform.svg",
        title: "Online Learning <br/> Management Platform",
      },
      {
        url: "/online-training-platform",
        image: "/images/feature_section_img/ic_online_training_platform.svg",
        title: "Online Training  <br/> Platform",
      },
    ],
    key: "SpecializedFeatures", // optional for style usage
  };

  const featureData = {
    ...defaultData,
    ...data,
    card: Array.isArray(data?.card) ? data.card : defaultData.card,
  };

    function createMarkup(content) {
    return { __html: content };
  }
  const chunkedCards = chunkArray(featureData.card, chunkSize);

  return (
    <section className={`${style["our-feature"]} ourpremiumservice`}>
      <div className={`container ${style["container"]} ${style["content-wrapper"]}`}>
        <div className={`${style["headingmain"]}`}>
          {featureData.preheading && <p className={`${style["section-title"]}`}>{featureData.preheading}</p>}
          <h2 className={`${style["section-heading"]} sectiontitle`}>{featureData.heading}</h2>
          {featureData.decsription && (
                <p
                  className={`${style["descheading"]} text-center`}
                  dangerouslySetInnerHTML={createMarkup(featureData.decsription)}
                ></p>
              )}
        </div>

       
          {isMobile ? (
            <ResponsiveSwiper
              swiperConfig={{
                spaceBetween: 20,
                loop: true,
                autoplay: {
                  delay: 2500,
                  disableOnInteraction: false,
                },
                navigation: true,
                className: "commonswiperclass prevnextpadding whitearrow",
              }}
            >
              {chunkedCards.map((group, index) => (
                <div key={index} className={style["slide-column-wrapper"]}>
                  {group.map((item, innerIndex) => (
                    <Link key={innerIndex} href={item.url} className={`${style["singleboxmain"]} ${style["singleboxmainmobile"]}`}>
                      <div className={`${style["singleboximgdiv"]}`}>
                        <Image src={item.image} alt={item.title} width={0} height={0} />
                      </div>
                      <div
                        className={`${style["links"]} ${style["singletitle"]}`}
                        dangerouslySetInnerHTML={{ __html: item.title }}
                       ></div>
                    </Link>
                  ))}
                </div>
              ))}
            </ResponsiveSwiper>
          ) : (
            <div className= {`${style["cusrow"]} row`}>
              {featureData.card.map((item, i) => (
                <Link key={i} href={item.url} className={`${style["singleboxmain"]} ${style["singleboxmain2"]}`}>
               
                    <div className={`${style["singleboximgdiv"]}`}>
                      <Image src={item.image} alt={item.title} width={0} height={0} />
                    </div>
                    <div
                      className={`${style["links"]} ${style["singletitle"]}`}
                      dangerouslySetInnerHTML={{ __html: item.title }}
                   ></div>
              
                 </Link>
              ))}
            </div>
          )}
        </div>

    </section>
  );
};

export default SpecializedFeatures2;
